let element
let startingPositionTop
let listeningToScroll = false

function isLargeScreen() {
  return window.matchMedia('(min-width: 767px)').matches
}

function bindResizeEvent() {
  window.addEventListener('resize', () => {
    window.requestAnimationFrame(function step() {
      if (isLargeScreen()) {
        bindScrollEvent()
      } else if (listeningToScroll) {
        window.removeEventListener('scroll', listener)
        listeningToScroll = false
      }
    })
  })
}

function bindScrollEvent() {
  if (isLargeScreen() && !listeningToScroll) {
    window.addEventListener('scroll', listener)
    listeningToScroll = true
  }
}

function listener() {
  window.requestAnimationFrame(function step() {
    const elementTop = element.getBoundingClientRect().top
    const isSticking = elementTop <= startingPositionTop
    const offset =
      document.body.scrollTop > 190 || document.documentElement.scrollTop > 190

    if (offset && isSticking) {
      element.classList.add('is-sticking')
      document.body.style.paddingTop = '65px'
    } else {
      element.classList.remove('is-sticking')
      document.body.style.paddingTop = '0'
    }
  })
}

export default function () {
  element = document.querySelector('.nav-container')

  if (!element) {
    console.warn('No navigation to check for stickiness.')
    return
  }

  const radix = 10
  startingPositionTop = parseInt(window.getComputedStyle(element).top, radix)

  bindResizeEvent()
  bindScrollEvent()
}
